const Ct = Math.min, F = Math.max, st = Math.round, H = (e) => ({
  x: e,
  y: e
});
function ne(e, t) {
  return e;
}
function ft(e) {
  return e.split("-")[0];
}
function Dt(e) {
  return e.split("-")[1];
}
function re(e) {
  return e === "x" ? "y" : "x";
}
function ae(e) {
  return e === "y" ? "height" : "width";
}
function wt(e) {
  return ["top", "bottom"].includes(ft(e)) ? "y" : "x";
}
function le(e) {
  return re(wt(e));
}
function jt(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function At(e, t, o) {
  let {
    reference: i,
    floating: s
  } = e;
  const r = wt(t), n = le(t), l = ae(n), a = ft(t), c = r === "y", d = i.x + i.width / 2 - s.width / 2, h = i.y + i.height / 2 - s.height / 2, m = i[l] / 2 - s[l] / 2;
  let g;
  switch (a) {
    case "top":
      g = {
        x: d,
        y: i.y - s.height
      };
      break;
    case "bottom":
      g = {
        x: d,
        y: i.y + i.height
      };
      break;
    case "right":
      g = {
        x: i.x + i.width,
        y: h
      };
      break;
    case "left":
      g = {
        x: i.x - s.width,
        y: h
      };
      break;
    default:
      g = {
        x: i.x,
        y: i.y
      };
  }
  switch (Dt(t)) {
    case "start":
      g[n] -= m * (o && c ? -1 : 1);
      break;
    case "end":
      g[n] += m * (o && c ? -1 : 1);
      break;
  }
  return g;
}
const ce = async (e, t, o) => {
  const {
    placement: i = "bottom",
    strategy: s = "absolute",
    middleware: r = [],
    platform: n
  } = o, l = r.filter(Boolean), a = await (n.isRTL == null ? void 0 : n.isRTL(t));
  let c = await n.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: d,
    y: h
  } = At(c, i, a), m = i, g = {}, w = 0;
  for (let $ = 0; $ < l.length; $++) {
    const {
      name: C,
      fn: tt
    } = l[$], {
      x: I,
      y: et,
      data: dt,
      reset: M
    } = await tt({
      x: d,
      y: h,
      initialPlacement: i,
      placement: m,
      strategy: s,
      middlewareData: g,
      rects: c,
      platform: n,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (d = I ?? d, h = et ?? h, g = {
      ...g,
      [C]: {
        ...g[C],
        ...dt
      }
    }, M && w <= 50) {
      w++, typeof M == "object" && (M.placement && (m = M.placement), M.rects && (c = M.rects === !0 ? await n.getElementRects({
        reference: e,
        floating: t,
        strategy: s
      }) : M.rects), {
        x: d,
        y: h
      } = At(c, m, a)), $ = -1;
      continue;
    }
  }
  return {
    x: d,
    y: h,
    placement: m,
    strategy: s,
    middlewareData: g
  };
};
async function he(e, t) {
  const {
    placement: o,
    platform: i,
    elements: s
  } = e, r = await (i.isRTL == null ? void 0 : i.isRTL(s.floating)), n = ft(o), l = Dt(o), a = wt(o) === "y", c = ["left", "top"].includes(n) ? -1 : 1, d = r && a ? -1 : 1, h = ne(t);
  let {
    mainAxis: m,
    crossAxis: g,
    alignmentAxis: w
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...h
  };
  return l && typeof w == "number" && (g = l === "end" ? w * -1 : w), a ? {
    x: g * d,
    y: m * c
  } : {
    x: m * c,
    y: g * d
  };
}
const de = function(e) {
  return {
    name: "offset",
    options: e,
    async fn(t) {
      var o, i;
      const {
        x: s,
        y: r,
        placement: n,
        middlewareData: l
      } = t, a = await he(t, e);
      return n === ((o = l.offset) == null ? void 0 : o.placement) && (i = l.arrow) != null && i.alignmentOffset ? {} : {
        x: s + a.x,
        y: r + a.y,
        data: {
          ...a,
          placement: n
        }
      };
    }
  };
};
function L(e) {
  return Ft(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function b(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function V(e) {
  var t;
  return (t = (Ft(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ft(e) {
  return e instanceof Node || e instanceof b(e).Node;
}
function A(e) {
  return e instanceof Element || e instanceof b(e).Element;
}
function x(e) {
  return e instanceof HTMLElement || e instanceof b(e).HTMLElement;
}
function St(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof b(e).ShadowRoot;
}
function J(e) {
  const {
    overflow: t,
    overflowX: o,
    overflowY: i,
    display: s
  } = _(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + i + o) && !["inline", "contents"].includes(s);
}
function pe(e) {
  return ["table", "td", "th"].includes(L(e));
}
function yt(e) {
  const t = $t(), o = _(e);
  return o.transform !== "none" || o.perspective !== "none" || (o.containerType ? o.containerType !== "normal" : !1) || !t && (o.backdropFilter ? o.backdropFilter !== "none" : !1) || !t && (o.filter ? o.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((i) => (o.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (o.contain || "").includes(i));
}
function ue(e) {
  let t = Z(e);
  for (; x(t) && !at(t); ) {
    if (yt(t))
      return t;
    t = Z(t);
  }
  return null;
}
function $t() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function at(e) {
  return ["html", "body", "#document"].includes(L(e));
}
function _(e) {
  return b(e).getComputedStyle(e);
}
function lt(e) {
  return A(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Z(e) {
  if (L(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    St(e) && e.host || // Fallback.
    V(e)
  );
  return St(t) ? t.host : t;
}
function zt(e) {
  const t = Z(e);
  return at(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : x(t) && J(t) ? t : zt(t);
}
function vt(e, t, o) {
  var i;
  t === void 0 && (t = []), o === void 0 && (o = !0);
  const s = zt(e), r = s === ((i = e.ownerDocument) == null ? void 0 : i.body), n = b(s);
  return r ? t.concat(n, n.visualViewport || [], J(s) ? s : [], n.frameElement && o ? vt(n.frameElement) : []) : t.concat(s, vt(s, [], o));
}
function Wt(e) {
  const t = _(e);
  let o = parseFloat(t.width) || 0, i = parseFloat(t.height) || 0;
  const s = x(e), r = s ? e.offsetWidth : o, n = s ? e.offsetHeight : i, l = st(o) !== r || st(i) !== n;
  return l && (o = r, i = n), {
    width: o,
    height: i,
    $: l
  };
}
function qt(e) {
  return A(e) ? e : e.contextElement;
}
function U(e) {
  const t = qt(e);
  if (!x(t))
    return H(1);
  const o = t.getBoundingClientRect(), {
    width: i,
    height: s,
    $: r
  } = Wt(t);
  let n = (r ? st(o.width) : o.width) / i, l = (r ? st(o.height) : o.height) / s;
  return (!n || !Number.isFinite(n)) && (n = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: n,
    y: l
  };
}
const ge = /* @__PURE__ */ H(0);
function Xt(e) {
  const t = b(e);
  return !$t() || !t.visualViewport ? ge : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function me(e, t, o) {
  return t === void 0 && (t = !1), !o || t && o !== b(e) ? !1 : t;
}
function X(e, t, o, i) {
  t === void 0 && (t = !1), o === void 0 && (o = !1);
  const s = e.getBoundingClientRect(), r = qt(e);
  let n = H(1);
  t && (i ? A(i) && (n = U(i)) : n = U(e));
  const l = me(r, o, i) ? Xt(r) : H(0);
  let a = (s.left + l.x) / n.x, c = (s.top + l.y) / n.y, d = s.width / n.x, h = s.height / n.y;
  if (r) {
    const m = b(r), g = i && A(i) ? b(i) : i;
    let w = m, $ = w.frameElement;
    for (; $ && i && g !== w; ) {
      const C = U($), tt = $.getBoundingClientRect(), I = _($), et = tt.left + ($.clientLeft + parseFloat(I.paddingLeft)) * C.x, dt = tt.top + ($.clientTop + parseFloat(I.paddingTop)) * C.y;
      a *= C.x, c *= C.y, d *= C.x, h *= C.y, a += et, c += dt, w = b($), $ = w.frameElement;
    }
  }
  return jt({
    width: d,
    height: h,
    x: a,
    y: c
  });
}
const ve = [":popover-open", ":modal"];
function Yt(e) {
  return ve.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function fe(e) {
  let {
    elements: t,
    rect: o,
    offsetParent: i,
    strategy: s
  } = e;
  const r = s === "fixed", n = V(i), l = t ? Yt(t.floating) : !1;
  if (i === n || l && r)
    return o;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = H(1);
  const d = H(0), h = x(i);
  if ((h || !h && !r) && ((L(i) !== "body" || J(n)) && (a = lt(i)), x(i))) {
    const m = X(i);
    c = U(i), d.x = m.x + i.clientLeft, d.y = m.y + i.clientTop;
  }
  return {
    width: o.width * c.x,
    height: o.height * c.y,
    x: o.x * c.x - a.scrollLeft * c.x + d.x,
    y: o.y * c.y - a.scrollTop * c.y + d.y
  };
}
function we(e) {
  return Array.from(e.getClientRects());
}
function Kt(e) {
  return X(V(e)).left + lt(e).scrollLeft;
}
function ye(e) {
  const t = V(e), o = lt(e), i = e.ownerDocument.body, s = F(t.scrollWidth, t.clientWidth, i.scrollWidth, i.clientWidth), r = F(t.scrollHeight, t.clientHeight, i.scrollHeight, i.clientHeight);
  let n = -o.scrollLeft + Kt(e);
  const l = -o.scrollTop;
  return _(i).direction === "rtl" && (n += F(t.clientWidth, i.clientWidth) - s), {
    width: s,
    height: r,
    x: n,
    y: l
  };
}
function $e(e, t) {
  const o = b(e), i = V(e), s = o.visualViewport;
  let r = i.clientWidth, n = i.clientHeight, l = 0, a = 0;
  if (s) {
    r = s.width, n = s.height;
    const c = $t();
    (!c || c && t === "fixed") && (l = s.offsetLeft, a = s.offsetTop);
  }
  return {
    width: r,
    height: n,
    x: l,
    y: a
  };
}
function be(e, t) {
  const o = X(e, !0, t === "fixed"), i = o.top + e.clientTop, s = o.left + e.clientLeft, r = x(e) ? U(e) : H(1), n = e.clientWidth * r.x, l = e.clientHeight * r.y, a = s * r.x, c = i * r.y;
  return {
    width: n,
    height: l,
    x: a,
    y: c
  };
}
function Et(e, t, o) {
  let i;
  if (t === "viewport")
    i = $e(e, o);
  else if (t === "document")
    i = ye(V(e));
  else if (A(t))
    i = be(t, o);
  else {
    const s = Xt(e);
    i = {
      ...t,
      x: t.x - s.x,
      y: t.y - s.y
    };
  }
  return jt(i);
}
function Gt(e, t) {
  const o = Z(e);
  return o === t || !A(o) || at(o) ? !1 : _(o).position === "fixed" || Gt(o, t);
}
function _e(e, t) {
  const o = t.get(e);
  if (o)
    return o;
  let i = vt(e, [], !1).filter((l) => A(l) && L(l) !== "body"), s = null;
  const r = _(e).position === "fixed";
  let n = r ? Z(e) : e;
  for (; A(n) && !at(n); ) {
    const l = _(n), a = yt(n);
    !a && l.position === "fixed" && (s = null), (r ? !a && !s : !a && l.position === "static" && !!s && ["absolute", "fixed"].includes(s.position) || J(n) && !a && Gt(e, n)) ? i = i.filter((d) => d !== n) : s = l, n = Z(n);
  }
  return t.set(e, i), i;
}
function xe(e) {
  let {
    element: t,
    boundary: o,
    rootBoundary: i,
    strategy: s
  } = e;
  const n = [...o === "clippingAncestors" ? _e(t, this._c) : [].concat(o), i], l = n[0], a = n.reduce((c, d) => {
    const h = Et(t, d, s);
    return c.top = F(h.top, c.top), c.right = Ct(h.right, c.right), c.bottom = Ct(h.bottom, c.bottom), c.left = F(h.left, c.left), c;
  }, Et(t, l, s));
  return {
    width: a.right - a.left,
    height: a.bottom - a.top,
    x: a.left,
    y: a.top
  };
}
function Ce(e) {
  const {
    width: t,
    height: o
  } = Wt(e);
  return {
    width: t,
    height: o
  };
}
function Ae(e, t, o) {
  const i = x(t), s = V(t), r = o === "fixed", n = X(e, !0, r, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = H(0);
  if (i || !i && !r)
    if ((L(t) !== "body" || J(s)) && (l = lt(t)), i) {
      const h = X(t, !0, r, t);
      a.x = h.x + t.clientLeft, a.y = h.y + t.clientTop;
    } else
      s && (a.x = Kt(s));
  const c = n.left + l.scrollLeft - a.x, d = n.top + l.scrollTop - a.y;
  return {
    x: c,
    y: d,
    width: n.width,
    height: n.height
  };
}
function Ht(e, t) {
  return !x(e) || _(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Jt(e, t) {
  const o = b(e);
  if (!x(e) || Yt(e))
    return o;
  let i = Ht(e, t);
  for (; i && pe(i) && _(i).position === "static"; )
    i = Ht(i, t);
  return i && (L(i) === "html" || L(i) === "body" && _(i).position === "static" && !yt(i)) ? o : i || ue(e) || o;
}
const Se = async function(e) {
  const t = this.getOffsetParent || Jt, o = this.getDimensions;
  return {
    reference: Ae(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await o(e.floating)
    }
  };
};
function Ee(e) {
  return _(e).direction === "rtl";
}
const He = {
  convertOffsetParentRelativeRectToViewportRelativeRect: fe,
  getDocumentElement: V,
  getClippingRect: xe,
  getOffsetParent: Jt,
  getElementRects: Se,
  getClientRects: we,
  getDimensions: Ce,
  getScale: U,
  isElement: A,
  isRTL: Ee
}, Le = (e, t, o) => {
  const i = /* @__PURE__ */ new Map(), s = {
    platform: He,
    ...o
  }, r = {
    ...s.platform,
    _c: i
  };
  return ce(e, t, {
    ...s,
    platform: r
  });
};
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const it = globalThis, bt = it.ShadowRoot && (it.ShadyCSS === void 0 || it.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, _t = Symbol(), Lt = /* @__PURE__ */ new WeakMap();
let Qt = class {
  constructor(t, o, i) {
    if (this._$cssResult$ = !0, i !== _t)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = o;
  }
  get styleSheet() {
    let t = this.o;
    const o = this.t;
    if (bt && t === void 0) {
      const i = o !== void 0 && o.length === 1;
      i && (t = Lt.get(o)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), i && Lt.set(o, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const Ve = (e) => new Qt(typeof e == "string" ? e : e + "", void 0, _t), Me = (e, ...t) => {
  const o = e.length === 1 ? e[0] : t.reduce((i, s, r) => i + ((n) => {
    if (n._$cssResult$ === !0)
      return n.cssText;
    if (typeof n == "number")
      return n;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + n + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(s) + e[r + 1], e[0]);
  return new Qt(o, e, _t);
}, Te = (e, t) => {
  if (bt)
    e.adoptedStyleSheets = t.map((o) => o instanceof CSSStyleSheet ? o : o.styleSheet);
  else
    for (const o of t) {
      const i = document.createElement("style"), s = it.litNonce;
      s !== void 0 && i.setAttribute("nonce", s), i.textContent = o.cssText, e.appendChild(i);
    }
}, Vt = bt ? (e) => e : (e) => e instanceof CSSStyleSheet ? ((t) => {
  let o = "";
  for (const i of t.cssRules)
    o += i.cssText;
  return Ve(o);
})(e) : e;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: ke, defineProperty: Pe, getOwnPropertyDescriptor: Ne, getOwnPropertyNames: Re, getOwnPropertySymbols: Oe, getPrototypeOf: Ue } = Object, E = globalThis, Mt = E.trustedTypes, Ze = Mt ? Mt.emptyScript : "", pt = E.reactiveElementPolyfillSupport, z = (e, t) => e, nt = { toAttribute(e, t) {
  switch (t) {
    case Boolean:
      e = e ? Ze : null;
      break;
    case Object:
    case Array:
      e = e == null ? e : JSON.stringify(e);
  }
  return e;
}, fromAttribute(e, t) {
  let o = e;
  switch (t) {
    case Boolean:
      o = e !== null;
      break;
    case Number:
      o = e === null ? null : Number(e);
      break;
    case Object:
    case Array:
      try {
        o = JSON.parse(e);
      } catch {
        o = null;
      }
  }
  return o;
} }, xt = (e, t) => !ke(e, t), Tt = { attribute: !0, type: String, converter: nt, reflect: !1, hasChanged: xt };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")), E.litPropertyMetadata ?? (E.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class O extends HTMLElement {
  static addInitializer(t) {
    this._$Ei(), (this.l ?? (this.l = [])).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, o = Tt) {
    if (o.state && (o.attribute = !1), this._$Ei(), this.elementProperties.set(t, o), !o.noAccessor) {
      const i = Symbol(), s = this.getPropertyDescriptor(t, i, o);
      s !== void 0 && Pe(this.prototype, t, s);
    }
  }
  static getPropertyDescriptor(t, o, i) {
    const { get: s, set: r } = Ne(this.prototype, t) ?? { get() {
      return this[o];
    }, set(n) {
      this[o] = n;
    } };
    return { get() {
      return s == null ? void 0 : s.call(this);
    }, set(n) {
      const l = s == null ? void 0 : s.call(this);
      r.call(this, n), this.requestUpdate(t, l, i);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? Tt;
  }
  static _$Ei() {
    if (this.hasOwnProperty(z("elementProperties")))
      return;
    const t = Ue(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(z("finalized")))
      return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(z("properties"))) {
      const o = this.properties, i = [...Re(o), ...Oe(o)];
      for (const s of i)
        this.createProperty(s, o[s]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const o = litPropertyMetadata.get(t);
      if (o !== void 0)
        for (const [i, s] of o)
          this.elementProperties.set(i, s);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [o, i] of this.elementProperties) {
      const s = this._$Eu(o, i);
      s !== void 0 && this._$Eh.set(s, o);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const o = [];
    if (Array.isArray(t)) {
      const i = new Set(t.flat(1 / 0).reverse());
      for (const s of i)
        o.unshift(Vt(s));
    } else
      t !== void 0 && o.push(Vt(t));
    return o;
  }
  static _$Eu(t, o) {
    const i = o.attribute;
    return i === !1 ? void 0 : typeof i == "string" ? i : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var t;
    this._$ES = new Promise((o) => this.enableUpdating = o), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (t = this.constructor.l) == null || t.forEach((o) => o(this));
  }
  addController(t) {
    var o;
    (this._$EO ?? (this._$EO = /* @__PURE__ */ new Set())).add(t), this.renderRoot !== void 0 && this.isConnected && ((o = t.hostConnected) == null || o.call(t));
  }
  removeController(t) {
    var o;
    (o = this._$EO) == null || o.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), o = this.constructor.elementProperties;
    for (const i of o.keys())
      this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return Te(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var t;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (t = this._$EO) == null || t.forEach((o) => {
      var i;
      return (i = o.hostConnected) == null ? void 0 : i.call(o);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$EO) == null || t.forEach((o) => {
      var i;
      return (i = o.hostDisconnected) == null ? void 0 : i.call(o);
    });
  }
  attributeChangedCallback(t, o, i) {
    this._$AK(t, i);
  }
  _$EC(t, o) {
    var r;
    const i = this.constructor.elementProperties.get(t), s = this.constructor._$Eu(t, i);
    if (s !== void 0 && i.reflect === !0) {
      const n = (((r = i.converter) == null ? void 0 : r.toAttribute) !== void 0 ? i.converter : nt).toAttribute(o, i.type);
      this._$Em = t, n == null ? this.removeAttribute(s) : this.setAttribute(s, n), this._$Em = null;
    }
  }
  _$AK(t, o) {
    var r;
    const i = this.constructor, s = i._$Eh.get(t);
    if (s !== void 0 && this._$Em !== s) {
      const n = i.getPropertyOptions(s), l = typeof n.converter == "function" ? { fromAttribute: n.converter } : ((r = n.converter) == null ? void 0 : r.fromAttribute) !== void 0 ? n.converter : nt;
      this._$Em = s, this[s] = l.fromAttribute(o, n.type), this._$Em = null;
    }
  }
  requestUpdate(t, o, i) {
    if (t !== void 0) {
      if (i ?? (i = this.constructor.getPropertyOptions(t)), !(i.hasChanged ?? xt)(this[t], o))
        return;
      this.P(t, o, i);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(t, o, i) {
    this._$AL.has(t) || this._$AL.set(t, o), i.reflect === !0 && this._$Em !== t && (this._$Ej ?? (this._$Ej = /* @__PURE__ */ new Set())).add(t);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (o) {
      Promise.reject(o);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var i;
    if (!this.isUpdatePending)
      return;
    if (!this.hasUpdated) {
      if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [r, n] of this._$Ep)
          this[r] = n;
        this._$Ep = void 0;
      }
      const s = this.constructor.elementProperties;
      if (s.size > 0)
        for (const [r, n] of s)
          n.wrapped !== !0 || this._$AL.has(r) || this[r] === void 0 || this.P(r, this[r], n);
    }
    let t = !1;
    const o = this._$AL;
    try {
      t = this.shouldUpdate(o), t ? (this.willUpdate(o), (i = this._$EO) == null || i.forEach((s) => {
        var r;
        return (r = s.hostUpdate) == null ? void 0 : r.call(s);
      }), this.update(o)) : this._$EU();
    } catch (s) {
      throw t = !1, this._$EU(), s;
    }
    t && this._$AE(o);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var o;
    (o = this._$EO) == null || o.forEach((i) => {
      var s;
      return (s = i.hostUpdated) == null ? void 0 : s.call(i);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((o) => this._$EC(o, this[o]))), this._$EU();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
}
O.elementStyles = [], O.shadowRootOptions = { mode: "open" }, O[z("elementProperties")] = /* @__PURE__ */ new Map(), O[z("finalized")] = /* @__PURE__ */ new Map(), pt == null || pt({ ReactiveElement: O }), (E.reactiveElementVersions ?? (E.reactiveElementVersions = [])).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const W = globalThis, rt = W.trustedTypes, kt = rt ? rt.createPolicy("lit-html", { createHTML: (e) => e }) : void 0, te = "$lit$", S = `lit$${Math.random().toFixed(9).slice(2)}$`, ee = "?" + S, Be = `<${ee}>`, P = document, Y = () => P.createComment(""), K = (e) => e === null || typeof e != "object" && typeof e != "function", oe = Array.isArray, Ie = (e) => oe(e) || typeof (e == null ? void 0 : e[Symbol.iterator]) == "function", ut = `[ 	
\f\r]`, D = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, Pt = /-->/g, Nt = />/g, T = RegExp(`>|${ut}(?:([^\\s"'>=/]+)(${ut}*=${ut}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), Rt = /'/g, Ot = /"/g, ie = /^(?:script|style|textarea|title)$/i, De = (e) => (t, ...o) => ({ _$litType$: e, strings: t, values: o }), y = De(1), N = Symbol.for("lit-noChange"), f = Symbol.for("lit-nothing"), Ut = /* @__PURE__ */ new WeakMap(), k = P.createTreeWalker(P, 129);
function se(e, t) {
  if (!Array.isArray(e) || !e.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return kt !== void 0 ? kt.createHTML(t) : t;
}
const je = (e, t) => {
  const o = e.length - 1, i = [];
  let s, r = t === 2 ? "<svg>" : "", n = D;
  for (let l = 0; l < o; l++) {
    const a = e[l];
    let c, d, h = -1, m = 0;
    for (; m < a.length && (n.lastIndex = m, d = n.exec(a), d !== null); )
      m = n.lastIndex, n === D ? d[1] === "!--" ? n = Pt : d[1] !== void 0 ? n = Nt : d[2] !== void 0 ? (ie.test(d[2]) && (s = RegExp("</" + d[2], "g")), n = T) : d[3] !== void 0 && (n = T) : n === T ? d[0] === ">" ? (n = s ?? D, h = -1) : d[1] === void 0 ? h = -2 : (h = n.lastIndex - d[2].length, c = d[1], n = d[3] === void 0 ? T : d[3] === '"' ? Ot : Rt) : n === Ot || n === Rt ? n = T : n === Pt || n === Nt ? n = D : (n = T, s = void 0);
    const g = n === T && e[l + 1].startsWith("/>") ? " " : "";
    r += n === D ? a + Be : h >= 0 ? (i.push(c), a.slice(0, h) + te + a.slice(h) + S + g) : a + S + (h === -2 ? l : g);
  }
  return [se(e, r + (e[o] || "<?>") + (t === 2 ? "</svg>" : "")), i];
};
class G {
  constructor({ strings: t, _$litType$: o }, i) {
    let s;
    this.parts = [];
    let r = 0, n = 0;
    const l = t.length - 1, a = this.parts, [c, d] = je(t, o);
    if (this.el = G.createElement(c, i), k.currentNode = this.el.content, o === 2) {
      const h = this.el.content.firstChild;
      h.replaceWith(...h.childNodes);
    }
    for (; (s = k.nextNode()) !== null && a.length < l; ) {
      if (s.nodeType === 1) {
        if (s.hasAttributes())
          for (const h of s.getAttributeNames())
            if (h.endsWith(te)) {
              const m = d[n++], g = s.getAttribute(h).split(S), w = /([.?@])?(.*)/.exec(m);
              a.push({ type: 1, index: r, name: w[2], strings: g, ctor: w[1] === "." ? ze : w[1] === "?" ? We : w[1] === "@" ? qe : ct }), s.removeAttribute(h);
            } else
              h.startsWith(S) && (a.push({ type: 6, index: r }), s.removeAttribute(h));
        if (ie.test(s.tagName)) {
          const h = s.textContent.split(S), m = h.length - 1;
          if (m > 0) {
            s.textContent = rt ? rt.emptyScript : "";
            for (let g = 0; g < m; g++)
              s.append(h[g], Y()), k.nextNode(), a.push({ type: 2, index: ++r });
            s.append(h[m], Y());
          }
        }
      } else if (s.nodeType === 8)
        if (s.data === ee)
          a.push({ type: 2, index: r });
        else {
          let h = -1;
          for (; (h = s.data.indexOf(S, h + 1)) !== -1; )
            a.push({ type: 7, index: r }), h += S.length - 1;
        }
      r++;
    }
  }
  static createElement(t, o) {
    const i = P.createElement("template");
    return i.innerHTML = t, i;
  }
}
function B(e, t, o = e, i) {
  var n, l;
  if (t === N)
    return t;
  let s = i !== void 0 ? (n = o._$Co) == null ? void 0 : n[i] : o._$Cl;
  const r = K(t) ? void 0 : t._$litDirective$;
  return (s == null ? void 0 : s.constructor) !== r && ((l = s == null ? void 0 : s._$AO) == null || l.call(s, !1), r === void 0 ? s = void 0 : (s = new r(e), s._$AT(e, o, i)), i !== void 0 ? (o._$Co ?? (o._$Co = []))[i] = s : o._$Cl = s), s !== void 0 && (t = B(e, s._$AS(e, t.values), s, i)), t;
}
class Fe {
  constructor(t, o) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = o;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    const { el: { content: o }, parts: i } = this._$AD, s = ((t == null ? void 0 : t.creationScope) ?? P).importNode(o, !0);
    k.currentNode = s;
    let r = k.nextNode(), n = 0, l = 0, a = i[0];
    for (; a !== void 0; ) {
      if (n === a.index) {
        let c;
        a.type === 2 ? c = new Q(r, r.nextSibling, this, t) : a.type === 1 ? c = new a.ctor(r, a.name, a.strings, this, t) : a.type === 6 && (c = new Xe(r, this, t)), this._$AV.push(c), a = i[++l];
      }
      n !== (a == null ? void 0 : a.index) && (r = k.nextNode(), n++);
    }
    return k.currentNode = P, s;
  }
  p(t) {
    let o = 0;
    for (const i of this._$AV)
      i !== void 0 && (i.strings !== void 0 ? (i._$AI(t, i, o), o += i.strings.length - 2) : i._$AI(t[o])), o++;
  }
}
class Q {
  get _$AU() {
    var t;
    return ((t = this._$AM) == null ? void 0 : t._$AU) ?? this._$Cv;
  }
  constructor(t, o, i, s) {
    this.type = 2, this._$AH = f, this._$AN = void 0, this._$AA = t, this._$AB = o, this._$AM = i, this.options = s, this._$Cv = (s == null ? void 0 : s.isConnected) ?? !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const o = this._$AM;
    return o !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = o.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, o = this) {
    t = B(this, t, o), K(t) ? t === f || t == null || t === "" ? (this._$AH !== f && this._$AR(), this._$AH = f) : t !== this._$AH && t !== N && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : Ie(t) ? this.k(t) : this._(t);
  }
  S(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.S(t));
  }
  _(t) {
    this._$AH !== f && K(this._$AH) ? this._$AA.nextSibling.data = t : this.T(P.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    var r;
    const { values: o, _$litType$: i } = t, s = typeof i == "number" ? this._$AC(t) : (i.el === void 0 && (i.el = G.createElement(se(i.h, i.h[0]), this.options)), i);
    if (((r = this._$AH) == null ? void 0 : r._$AD) === s)
      this._$AH.p(o);
    else {
      const n = new Fe(s, this), l = n.u(this.options);
      n.p(o), this.T(l), this._$AH = n;
    }
  }
  _$AC(t) {
    let o = Ut.get(t.strings);
    return o === void 0 && Ut.set(t.strings, o = new G(t)), o;
  }
  k(t) {
    oe(this._$AH) || (this._$AH = [], this._$AR());
    const o = this._$AH;
    let i, s = 0;
    for (const r of t)
      s === o.length ? o.push(i = new Q(this.S(Y()), this.S(Y()), this, this.options)) : i = o[s], i._$AI(r), s++;
    s < o.length && (this._$AR(i && i._$AB.nextSibling, s), o.length = s);
  }
  _$AR(t = this._$AA.nextSibling, o) {
    var i;
    for ((i = this._$AP) == null ? void 0 : i.call(this, !1, !0, o); t && t !== this._$AB; ) {
      const s = t.nextSibling;
      t.remove(), t = s;
    }
  }
  setConnected(t) {
    var o;
    this._$AM === void 0 && (this._$Cv = t, (o = this._$AP) == null || o.call(this, t));
  }
}
class ct {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, o, i, s, r) {
    this.type = 1, this._$AH = f, this._$AN = void 0, this.element = t, this.name = o, this._$AM = s, this.options = r, i.length > 2 || i[0] !== "" || i[1] !== "" ? (this._$AH = Array(i.length - 1).fill(new String()), this.strings = i) : this._$AH = f;
  }
  _$AI(t, o = this, i, s) {
    const r = this.strings;
    let n = !1;
    if (r === void 0)
      t = B(this, t, o, 0), n = !K(t) || t !== this._$AH && t !== N, n && (this._$AH = t);
    else {
      const l = t;
      let a, c;
      for (t = r[0], a = 0; a < r.length - 1; a++)
        c = B(this, l[i + a], o, a), c === N && (c = this._$AH[a]), n || (n = !K(c) || c !== this._$AH[a]), c === f ? t = f : t !== f && (t += (c ?? "") + r[a + 1]), this._$AH[a] = c;
    }
    n && !s && this.j(t);
  }
  j(t) {
    t === f ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
  }
}
class ze extends ct {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === f ? void 0 : t;
  }
}
class We extends ct {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== f);
  }
}
class qe extends ct {
  constructor(t, o, i, s, r) {
    super(t, o, i, s, r), this.type = 5;
  }
  _$AI(t, o = this) {
    if ((t = B(this, t, o, 0) ?? f) === N)
      return;
    const i = this._$AH, s = t === f && i !== f || t.capture !== i.capture || t.once !== i.once || t.passive !== i.passive, r = t !== f && (i === f || s);
    s && this.element.removeEventListener(this.name, this, i), r && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var o;
    typeof this._$AH == "function" ? this._$AH.call(((o = this.options) == null ? void 0 : o.host) ?? this.element, t) : this._$AH.handleEvent(t);
  }
}
class Xe {
  constructor(t, o, i) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = o, this.options = i;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    B(this, t);
  }
}
const gt = W.litHtmlPolyfillSupport;
gt == null || gt(G, Q), (W.litHtmlVersions ?? (W.litHtmlVersions = [])).push("3.1.3");
const Ye = (e, t, o) => {
  const i = (o == null ? void 0 : o.renderBefore) ?? t;
  let s = i._$litPart$;
  if (s === void 0) {
    const r = (o == null ? void 0 : o.renderBefore) ?? null;
    i._$litPart$ = s = new Q(t.insertBefore(Y(), r), r, void 0, o ?? {});
  }
  return s._$AI(e), s;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class q extends O {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var o;
    const t = super.createRenderRoot();
    return (o = this.renderOptions).renderBefore ?? (o.renderBefore = t.firstChild), t;
  }
  update(t) {
    const o = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = Ye(o, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this._$Do) == null || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this._$Do) == null || t.setConnected(!1);
  }
  render() {
    return N;
  }
}
var It;
q._$litElement$ = !0, q.finalized = !0, (It = globalThis.litElementHydrateSupport) == null || It.call(globalThis, { LitElement: q });
const mt = globalThis.litElementPolyfillSupport;
mt == null || mt({ LitElement: q });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.0.5");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ke = (e) => (t, o) => {
  o !== void 0 ? o.addInitializer(() => {
    customElements.define(e, t);
  }) : customElements.define(e, t);
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ge = { attribute: !0, type: String, converter: nt, reflect: !1, hasChanged: xt }, Je = (e = Ge, t, o) => {
  const { kind: i, metadata: s } = o;
  let r = globalThis.litPropertyMetadata.get(s);
  if (r === void 0 && globalThis.litPropertyMetadata.set(s, r = /* @__PURE__ */ new Map()), r.set(o.name, e), i === "accessor") {
    const { name: n } = o;
    return { set(l) {
      const a = t.get.call(this);
      t.set.call(this, l), this.requestUpdate(n, a, e);
    }, init(l) {
      return l !== void 0 && this.P(n, void 0, e), l;
    } };
  }
  if (i === "setter") {
    const { name: n } = o;
    return function(l) {
      const a = this[n];
      t.call(this, l), this.requestUpdate(n, a, e);
    };
  }
  throw Error("Unsupported decorator location: " + i);
};
function v(e) {
  return (t, o) => typeof o == "object" ? Je(e, t, o) : ((i, s, r) => {
    const n = s.hasOwnProperty(r);
    return s.constructor.createProperty(r, n ? { ...i, wrapped: !0 } : i), n ? Object.getOwnPropertyDescriptor(s, r) : void 0;
  })(e, t, o);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function R(e) {
  return v({ ...e, state: !0, attribute: !1 });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Qe = (e, t, o) => (o.configurable = !0, o.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(e, t, o), o);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function ht(e, t) {
  return (o, i, s) => {
    const r = (n) => {
      var l;
      return ((l = n.renderRoot) == null ? void 0 : l.querySelector(e)) ?? null;
    };
    return Qe(o, i, { get() {
      return r(this);
    } });
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const to = { ATTRIBUTE: 1, CHILD: 2, PROPERTY: 3, BOOLEAN_ATTRIBUTE: 4, EVENT: 5, ELEMENT: 6 }, eo = (e) => (...t) => ({ _$litDirective$: e, values: t });
class oo {
  constructor(t) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t, o, i) {
    this._$Ct = t, this._$AM = o, this._$Ci = i;
  }
  _$AS(t, o) {
    return this.update(t, o);
  }
  update(t, o) {
    return this.render(...o);
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const j = eo(class extends oo {
  constructor(e) {
    var t;
    if (super(e), e.type !== to.ATTRIBUTE || e.name !== "class" || ((t = e.strings) == null ? void 0 : t.length) > 2)
      throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(e) {
    return " " + Object.keys(e).filter((t) => e[t]).join(" ") + " ";
  }
  update(e, [t]) {
    var i, s;
    if (this.st === void 0) {
      this.st = /* @__PURE__ */ new Set(), e.strings !== void 0 && (this.nt = new Set(e.strings.join(" ").split(/\s/).filter((r) => r !== "")));
      for (const r in t)
        t[r] && !((i = this.nt) != null && i.has(r)) && this.st.add(r);
      return this.render(t);
    }
    const o = e.element.classList;
    for (const r of this.st)
      r in t || (o.remove(r), this.st.delete(r));
    for (const r in t) {
      const n = !!t[r];
      n === this.st.has(r) || (s = this.nt) != null && s.has(r) || (n ? (o.add(r), this.st.add(r)) : (o.remove(r), this.st.delete(r)));
    }
    return N;
  }
}), io = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%2020C20%2020.5523%2019.5523%2021%2019%2021H5C4.44772%2021%204%2020.5523%204%2020V11L1%2011L11.3273%201.6115C11.7087%201.26475%2012.2913%201.26475%2012.6727%201.6115L23%2011L20%2011V20Z'/%3e%3c/svg%3e", so = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19%2021H5C4.44772%2021%204%2020.5523%204%2020V11L1%2011L11.3273%201.6115C11.7087%201.26475%2012.2913%201.26475%2012.6727%201.6115L23%2011L20%2011V20C20%2020.5523%2019.5523%2021%2019%2021ZM6%2019H18V9.15745L12%203.7029L6%209.15745V19Z'/%3e%3c/svg%3e", no = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22%209.999V20C22%2020.5523%2021.5523%2021%2021%2021H13V9.999H22ZM11%2015.999V21H3C2.44772%2021%202%2020.5523%202%2020V15.999H11ZM11%203V13.999H2V4C2%203.44772%202.44772%203%203%203H11ZM21%203C21.5523%203%2022%203.44772%2022%204V7.999H13V3H21Z'/%3e%3c/svg%3e", ro = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22%2020C22%2020.5523%2021.5523%2021%2021%2021H3C2.44772%2021%202%2020.5523%202%2020V4C2%203.44772%202.44772%203%203%203H21C21.5523%203%2022%203.44772%2022%204V20ZM11%2015H4V19H11V15ZM20%2011H13V19H20V11ZM11%205H4V13H11V5ZM20%205H13V9H20V5Z'/%3e%3c/svg%3e", Zt = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6%204V8H18V4H20.0066C20.5552%204%2021%204.44495%2021%204.9934V21.0066C21%2021.5552%2020.5551%2022%2020.0066%2022H3.9934C3.44476%2022%203%2021.5551%203%2021.0066V4.9934C3%204.44476%203.44495%204%203.9934%204H6ZM8%202H16V6H8V2Z'/%3e%3c/svg%3e", Bt = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7%204V2H17V4H20.0066C20.5552%204%2021%204.44495%2021%204.9934V21.0066C21%2021.5552%2020.5551%2022%2020.0066%2022H3.9934C3.44476%2022%203%2021.5551%203%2021.0066V4.9934C3%204.44476%203.44495%204%203.9934%204H7ZM7%206H5V20H19V6H17V8H7V6ZM9%204V6H15V4H9Z'/%3e%3c/svg%3e", ao = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22%208V20C22%2020.5523%2021.5523%2021%2021%2021H3C2.44772%2021%202%2020.5523%202%2020V7H21C21.5523%207%2022%207.44772%2022%208ZM12.4142%205H2V4C2%203.44772%202.44772%203%203%203H10.4142L12.4142%205Z'/%3e%3c/svg%3e", lo = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.4142%205H21C21.5523%205%2022%205.44772%2022%206V20C22%2020.5523%2021.5523%2021%2021%2021H3C2.44772%2021%202%2020.5523%202%2020V4C2%203.44772%202.44772%203%203%203H10.4142L12.4142%205ZM4%207V19H20V7H4Z'/%3e%3c/svg%3e", co = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M2.00488%2019H22.0049V21H2.00488V19ZM2.00488%205L7.00488%208L12.0049%202L17.0049%208L22.0049%205V17H2.00488V5Z'/%3e%3c/svg%3e", ho = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M2.00488%2019H22.0049V21H2.00488V19ZM2.00488%205L7.00488%208.5L12.0049%202L17.0049%208.5L22.0049%205V17H2.00488V5ZM4.00488%208.84131V15H20.0049V8.84131L16.5854%2011.2349L12.0049%205.28024L7.42435%2011.2349L4.00488%208.84131Z'/%3e%3c/svg%3e", po = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2011.1005L7%209.1005L12.5%2014.6005L16%2011.1005L19%2014.1005V5H5V11.1005ZM4%203H20C20.5523%203%2021%203.44772%2021%204V20C21%2020.5523%2020.5523%2021%2020%2021H4C3.44772%2021%203%2020.5523%203%2020V4C3%203.44772%203.44772%203%204%203ZM15.5%2010C14.6716%2010%2014%209.32843%2014%208.5C14%207.67157%2014.6716%207%2015.5%207C16.3284%207%2017%207.67157%2017%208.5C17%209.32843%2016.3284%2010%2015.5%2010Z'/%3e%3c/svg%3e", uo = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2011.1005L7%209.1005L12.5%2014.6005L16%2011.1005L19%2014.1005V5H5V11.1005ZM5%2013.9289V19H8.1005L11.0858%2016.0147L7%2011.9289L5%2013.9289ZM10.9289%2019H19V16.9289L16%2013.9289L10.9289%2019ZM4%203H20C20.5523%203%2021%203.44772%2021%204V20C21%2020.5523%2020.5523%2021%2020%2021H4C3.44772%2021%203%2020.5523%203%2020V4C3%203.44772%203.44772%203%204%203ZM15.5%2010C14.6716%2010%2014%209.32843%2014%208.5C14%207.67157%2014.6716%207%2015.5%207C16.3284%207%2017%207.67157%2017%208.5C17%209.32843%2016.3284%2010%2015.5%2010Z'/%3e%3c/svg%3e", go = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7%2010H20C20.5523%2010%2021%2010.4477%2021%2011V21C21%2021.5523%2020.5523%2022%2020%2022H4C3.44772%2022%203%2021.5523%203%2021V11C3%2010.4477%203.44772%2010%204%2010H5V9C5%205.13401%208.13401%202%2012%202C14.7405%202%2017.1131%203.5748%2018.2624%205.86882L16.4731%206.76344C15.6522%205.12486%2013.9575%204%2012%204C9.23858%204%207%206.23858%207%209V10ZM10%2015V17H14V15H10Z'/%3e%3c/svg%3e", mo = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7%2010H20C20.5523%2010%2021%2010.4477%2021%2011V21C21%2021.5523%2020.5523%2022%2020%2022H4C3.44772%2022%203%2021.5523%203%2021V11C3%2010.4477%203.44772%2010%204%2010H5V9C5%205.13401%208.13401%202%2012%202C14.7405%202%2017.1131%203.5748%2018.2624%205.86882L16.4731%206.76344C15.6522%205.12486%2013.9575%204%2012%204C9.23858%204%207%206.23858%207%209V10ZM5%2012V20H19V12H5ZM10%2015H14V17H10V15Z'/%3e%3c/svg%3e", vo = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M3%204H21V6H3V4ZM3%2011H21V13H3V11ZM3%2018H21V20H3V18Z'/%3e%3c/svg%3e", fo = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M2%2022C2%2017.5817%205.58172%2014%2010%2014C14.4183%2014%2018%2017.5817%2018%2022H2ZM10%2013C6.685%2013%204%2010.315%204%207C4%203.685%206.685%201%2010%201C13.315%201%2016%203.685%2016%207C16%2010.315%2013.315%2013%2010%2013ZM17.3628%2015.2332C20.4482%2016.0217%2022.7679%2018.7235%2022.9836%2022H20C20%2019.3902%2019.0002%2017.0139%2017.3628%2015.2332ZM15.3401%2012.9569C16.9728%2011.4922%2018%209.36607%2018%207C18%205.58266%2017.6314%204.25141%2016.9849%203.09687C19.2753%203.55397%2021%205.57465%2021%208C21%2010.7625%2018.7625%2013%2016%2013C15.7763%2013%2015.556%2012.9853%2015.3401%2012.9569Z'/%3e%3c/svg%3e", wo = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M2%2022C2%2017.5817%205.58172%2014%2010%2014C14.4183%2014%2018%2017.5817%2018%2022H16C16%2018.6863%2013.3137%2016%2010%2016C6.68629%2016%204%2018.6863%204%2022H2ZM10%2013C6.685%2013%204%2010.315%204%207C4%203.685%206.685%201%2010%201C13.315%201%2016%203.685%2016%207C16%2010.315%2013.315%2013%2010%2013ZM10%2011C12.21%2011%2014%209.21%2014%207C14%204.79%2012.21%203%2010%203C7.79%203%206%204.79%206%207C6%209.21%207.79%2011%2010%2011ZM18.2837%2014.7028C21.0644%2015.9561%2023%2018.752%2023%2022H21C21%2019.564%2019.5483%2017.4671%2017.4628%2016.5271L18.2837%2014.7028ZM17.5962%203.41321C19.5944%204.23703%2021%206.20361%2021%208.5C21%2011.3702%2018.8042%2013.7252%2016%2013.9776V11.9646C17.6967%2011.7222%2019%2010.264%2019%208.5C19%207.11935%2018.2016%205.92603%2017.041%205.35635L17.5962%203.41321Z'/%3e%3c/svg%3e", yo = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%2022H4V20C4%2017.2386%206.23858%2015%209%2015H15C17.7614%2015%2020%2017.2386%2020%2020V22ZM12%2013C8.68629%2013%206%2010.3137%206%207C6%203.68629%208.68629%201%2012%201C15.3137%201%2018%203.68629%2018%207C18%2010.3137%2015.3137%2013%2012%2013Z'/%3e%3c/svg%3e", $o = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%2022H18V20C18%2018.3431%2016.6569%2017%2015%2017H9C7.34315%2017%206%2018.3431%206%2020V22H4V20C4%2017.2386%206.23858%2015%209%2015H15C17.7614%2015%2020%2017.2386%2020%2020V22ZM12%2013C8.68629%2013%206%2010.3137%206%207C6%203.68629%208.68629%201%2012%201C15.3137%201%2018%203.68629%2018%207C18%2010.3137%2015.3137%2013%2012%2013ZM12%2011C14.2091%2011%2016%209.20914%2016%207C16%204.79086%2014.2091%203%2012%203C9.79086%203%208%204.79086%208%207C8%209.20914%209.79086%2011%2012%2011Z'/%3e%3c/svg%3e", bo = "Adgangskontrol", _o = "Konti", xo = "Fold navigation sammen", Co = "Skift til mørkt tema", Ao = "Skift til lyst tema", So = "Skift tema", Eo = "Virksomhed", Ho = "Kontakter", Lo = "Tilpassede rapporter", Vo = "Dashboard", Mo = "Fold navigation ud", To = "Hjælp", ko = "Inspektioner", Po = "Invitation", No = "Invitationer", Ro = "Profil", Oo = "Projekter", Uo = "Rapportskabeloner", Zo = "Indstillinger", Bo = "Log ud", Io = "Skabeloner", Do = "Brugere", jo = {
  accessControl: bo,
  accounts: _o,
  collapse: xo,
  colorSchemeDark: Co,
  colorSchemeLight: Ao,
  colorSchemeToggle: So,
  company: Eo,
  contacts: Ho,
  customReports: Lo,
  dashboard: Vo,
  expand: Mo,
  help: To,
  inspections: ko,
  invitations: Po,
  invitations_plural: No,
  profile: Ro,
  projects: Oo,
  reportTemplates: Uo,
  settings: Zo,
  signOut: Bo,
  templates: Io,
  users: Do
}, Fo = "Access control", zo = "Accounts", Wo = "Collapse navigation", qo = "Change to dark theme", Xo = "Change to light theme", Yo = "Change theme", Ko = "Company", Go = "Contacts", Jo = "Custom reports", Qo = "Dashboard", ti = "Expand navigation", ei = "help", oi = "Inspections", ii = "Invitation", si = "Invitations", ni = "Profile", ri = "Projects", ai = "Report templates", li = "Settings", ci = "Sign out", hi = "Templates", di = "Users", pi = {
  accessControl: Fo,
  accounts: zo,
  collapse: Wo,
  colorSchemeDark: qo,
  colorSchemeLight: Xo,
  colorSchemeToggle: Yo,
  company: Ko,
  contacts: Go,
  customReports: Jo,
  dashboard: Qo,
  expand: ti,
  help: ei,
  inspections: oi,
  invitations: ii,
  invitations_plural: si,
  profile: ni,
  projects: ri,
  reportTemplates: ai,
  settings: li,
  signOut: ci,
  templates: hi,
  users: di
}, ui = "Access control", gi = "Accounts", mi = "Collapse navigation", vi = "Change to dark theme", fi = "Change to light theme", wi = "Change theme", yi = "Company", $i = "Contacts", bi = "Custom reports", _i = "Dashboard", xi = "Expand navigation", Ci = "Help", Ai = "Inspections", Si = "Invitation", Ei = "Invitations", Hi = "Profile", Li = "Projects", Vi = "Report templates", Mi = "Settings", Ti = "Sign out", ki = "Templates", Pi = "Users", Ni = {
  accessControl: ui,
  accounts: gi,
  collapse: mi,
  colorSchemeDark: vi,
  colorSchemeLight: fi,
  colorSchemeToggle: wi,
  company: yi,
  contacts: $i,
  customReports: bi,
  dashboard: _i,
  expand: xi,
  help: Ci,
  inspections: Ai,
  invitations: Si,
  invitations_plural: Ei,
  profile: Hi,
  projects: Li,
  reportTemplates: Vi,
  settings: Mi,
  signOut: Ti,
  templates: ki,
  users: Pi
};
function ot() {
  let e = !1;
  return window.PointerEvent && "maxTouchPoints" in navigator ? navigator.maxTouchPoints > 0 && (e = !0) : (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches || window.TouchEvent || "ontouchstart" in window) && (e = !0), e;
}
var Ri = Object.defineProperty, Oi = Object.getOwnPropertyDescriptor, u = (e, t, o, i) => {
  for (var s = i > 1 ? void 0 : i ? Oi(t, o) : t, r = e.length - 1, n; r >= 0; r--)
    (n = e[r]) && (s = (i ? n(t, o, s) : n(s)) || s);
  return i && s && Ri(t, o, s), s;
};
const Ui = {
  "da-DK": jo,
  "en-GB": pi,
  "en-US": Ni
};
let p = class extends q {
  constructor() {
    super(...arguments), this.colorScheme = "light", this.companyId = void 0, this.companyName = void 0, this.customReportsUrl = void 0, this.isExpanded = void 0, this.isLoading = void 0, this.invitations = 0, this.logo = void 0, this.locale = "en-US", this.routePath = void 0, this.showAccessControl = void 0, this.showAccounts = void 0, this.showCustomReports = void 0, this.showReportTemplates = void 0, this.showCompany = void 0, this.showTemplates = void 0, this.userId = void 0, this.userEmail = void 0, this.userName = void 0, this.userPhoneNumber = void 0, this._isAccountShown = !1, this._isNavigationHovered = !1, this._logoCenterX = 0, this._logoCenterY = 0, this._isSmallScreen = !1, this._wasExpanded = !1, this._handleScreenChange = (e) => {
      !this._isSmallScreen && e.matches && (this._wasExpanded = !!this.isExpanded, this._collapseNavigation()), this._isSmallScreen && !e.matches && this._wasExpanded && this._expandNavigation(), this._isSmallScreen = e.matches;
    }, this._togglePopover = () => {
      this._isAccountShown ? this._hidePopover() : this._showPopover();
    }, this._showPopover = () => {
      var e, t;
      (e = this.navEl) == null || e.addEventListener("click", this._isClickOutsidePopover, !1), (t = this.popoverContentEl) == null || t.classList.add("is-active"), this._isAccountShown = !0, this._updatePopover();
    }, this._hidePopover = () => {
      var e, t;
      (e = this.navEl) == null || e.removeEventListener("click", this._isClickOutsidePopover, !1), (t = this.popoverContentEl) == null || t.classList.remove("is-active"), this._isAccountShown = !1;
    }, this._isClickOutsidePopover = (e) => {
      var o;
      const t = e.target;
      t != null && t !== this.popoverTriggerEl && !((o = this.popoverTriggerEl) != null && o.contains(t)) && this._hidePopover();
    }, this._documentClickHandler = (e) => {
      e.target !== this && this._isAccountShown && this._hidePopover();
    };
  }
  firstUpdated() {
    var e;
    this._updatePopover(), (e = this.popoverTriggerEl) == null || e.addEventListener("click", this._togglePopover);
  }
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this._documentClickHandler), this._mql = window.matchMedia("(max-width: 44.9rem)"), this._mql.addEventListener("change", this._handleScreenChange), this._handleScreenChange(this._mql);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this._documentClickHandler), this._mql != null && this._mql.removeEventListener("change", this._handleScreenChange);
  }
  render() {
    return y`
      <div class=${j({
      wrapper: !0,
      "is-collapsed": !this.isExpanded,
      "is-hovered": this._isNavigationHovered || this._isAccountShown,
      "is-touch": ot()
    })}>
        <button class="toggle-mobile" type="button" title=${this._t(
      this.isExpanded ? "collapse" : "expand"
    )} @click=${this._toggleNavigation}>
          <img aria-hidden="true" focusable="false" src=${vo} alt="" />
        </button>
        <div
          class="nav"
          @mouseenter=${this._enterNavigation}
          @mouseleave=${this._leaveNavigation}
        >
          <div class="top">
            <div ref="logoContainer" class="logo">
              <a href="/" @click=${this.navigate}>
                ${!this.isLoading && this.logo ? y`<img
                        src=${this.logo}
                        style=${`
                          --center-x': ${this._logoCenterX}
                          --center-y': ${this._logoCenterY}
                        `}
                        alt=${`${this.companyName} logo`}
                        @load=${this._logoLoaded}
                      />` : null}

                ${!this.isLoading && !this.logo ? y`<svg viewBox="0 0 512 512">
                        <path
                          fill="#fff"
                          d="M442 0H70A70 70 0 0 0 0 70v372a70 70 0 0 0 70 70h372a70 70 0 0 0 70-70V70a70 70 0 0 0-70-70Z"
                        />
                        <path
                          fill="#FB5F8E"
                          d="M164.96 70.06h-60.08a34.83 34.83 0 0 0-34.82 34.82v56.2H35.23v-56.2a69.65 69.65 0 0 1 69.65-69.65h60.08v34.83Z"
                        />
                        <path
                          fill="#4C6EE9"
                          d="M347.04 70.06h60.08a34.83 34.83 0 0 1 34.82 34.82v56.2h34.83v-56.2a69.65 69.65 0 0 0-69.65-69.65h-60.08v34.83Z"
                        />
                        <path
                          fill="#5FCFDA"
                          d="M164.96 441.94h-60.08a34.83 34.83 0 0 1-34.82-34.82v-56.2H35.23v56.2a69.65 69.65 0 0 0 69.65 69.65h60.08v-34.83Z"
                        />
                        <path
                          fill="#EBD146"
                          d="M347.04 441.94h60.08a34.83 34.83 0 0 0 34.82-34.82v-56.2h34.83v56.2a69.65 69.65 0 0 1-69.65 69.65h-60.08v-34.83Z"
                        />
                        <path
                          fill="#002828"
                          d="M356.45 205.8a112.32 112.32 0 1 0 6 85.76l-53.26-17.82a56.17 56.17 0 1 1-3-42.88l50.26-25.06Z"
                        />
                      </svg> ` : null}
              </a>
            </div>

            <button
              class=${j({
      toggle: !0,
      "toggle-primary": !0,
      "is-hidden": ot()
    })}
              title=${this._t(this.isExpanded ? "collapse" : "expand")}
              type="button"
            "
              @click=${this._toggleNavigation}
            >
              <svg width="6" height="9" fill="none">
                <path
                  fill="currentColor"
                  d="M1.94 4.364 5.333.97 4.364 0 0 4.364l4.364 4.364.97-.97-3.395-3.394Z"
                />
              </svg>
            </button>
          </div>

          <nav class="middle">
            <ul class="list">
              <li class="divider-below">
                ${this._renderItem({
      href: "/",
      exact: !0,
      iconLine: so,
      iconFill: io,
      title: this._t("dashboard")
    })}
              </li>

              <li>
                ${this._renderItem({
      href: "/projects",
      iconLine: lo,
      iconFill: ao,
      title: this._t("projects")
    })}
              </li>

              <li>
                ${this._renderItem({
      href: "/inspections",
      iconLine: uo,
      iconFill: po,
      title: this._t("inspections")
    })}
              </li>

              ${this.showTemplates ? y`<li>
                      ${this._renderItem({
      href: "/templates",
      iconLine: ro,
      iconFill: no,
      title: this._t("templates")
    })}
                    </li>` : null}

              ${this.showCustomReports && this.customReportsUrl ? y`<li>
                      ${this._renderItem({
      href: this.customReportsUrl,
      iconLine: Bt,
      iconFill: Zt,
      title: this._t("customReports")
    })}
                    </li>` : null}
              ${this.showReportTemplates ? y`<li>
                      ${this._renderItem({
      href: "/report-templates",
      iconLine: Bt,
      iconFill: Zt,
      title: this._t("reportTemplates")
    })}
                    </li>` : null}
              ${this.showAccessControl ? y`<li>
                      ${this._renderItem({
      href: "/access-control",
      iconLine: mo,
      iconFill: go,
      title: this._t("accessControl")
    })}
                    </li>` : null}
              ${this.showAccounts ? y`<li>
                      ${this._renderItem({
      href: "/accounts",
      iconLine: wo,
      iconFill: fo,
      title: this._t("accounts")
    })}
                    </li>` : null}
              ${this.showCompany ? y`<li class="divider-above">
                      ${this._renderItem({
      href: "/company",
      iconLine: ho,
      iconFill: co,
      isParent: !0,
      title: this._t("company")
    })}
                      <ul class="sublist">
                        <li>
                          ${this._renderSubItem({
      exact: !0,
      href: "/company",
      title: this._t("settings")
    })}
                        </li>

                        <li>
                          ${this._renderSubItem({
      href: "/company/users",
      title: this._t("users")
    })}
                        </li>

                        <li>
                          ${this._renderSubItem({
      href: "/company/contacts",
      title: this._t("contacts")
    })}
                        </li>
                      </ul>
                    </li>` : null}
            </ul>
          </nav>

          <div class="bottom">
            ${this.invitations != null && this.invitations > 0 ? y`<button
                    class="item invitations"
                    type="button"
                    @click=${this._showInvitations}
                  >
                    <div class="invitations-counter">${this.invitations}</div>
                    <div class="title">${this._t("invitations")}</div>
                  </button>` : null}

            <button class="item popover-trigger" type="button">
              <div class="icon">
                <img aria-hidden="true" focusable="false" src=${$o} alt="" />
                <img aria-hidden="true" focusable="false" src=${yo} alt="" />
              </div>
              <div class="title">
                <div class="vstack-sm">
                  <div class="title" data-id=${this.userId}>
                    ${this.userName}
                  </div>
                  <div
                    class="text-muted text-xxs"
                    data-id=${this.companyId}
                  >${this.companyName}
                  </div>
                </div>
              </div>
            </button>



            <button
              class=${j({
      toggle: !0,
      "toggle-secondary": !0,
      "is-hidden": !ot()
    })}
              title=${this._t(this.isExpanded ? "collapse" : "expand")}
            "
            type="button"
              @click=${this._toggleNavigation}
            >
              <svg width="6" height="9" fill="none">
                <path
                  fill="currentColor"
                  d="M1.94 4.364 5.333.97 4.364 0 0 4.364l4.364 4.364.97-.97-3.395-3.394Z"
                />
              </svg>
            </button>
          </div>
        </div>

        <div class="popover-content">
          <ul ref="accountlist" class="accountlist list-plain">
            <li class="divider-below">
              <div class="user-info vstack-sm">
                <div class="title" data-id=${this.userId}>
                  ${this.userName}
                </div>
                <div
                  class="text-muted text-xxs vstack-sm"
                  data-id=${this.companyId}
                >
                  ${this.companyName}
                  ${this.userEmail != null ? y`<div>${this.userEmail}</div>` : null}
                  ${this.userPhoneNumber != null ? y`<div>${this.userPhoneNumber}</div>` : null}
                </div>
              </div>
            </li>
            <li>
              ${this._renderSubItem({
      exact: !0,
      href: "/profile",
      title: this._t("profile")
    })}
            </li>
            <li>
              <button
                class="item subitem"
                title=${this._t(
      this.colorScheme === "dark" ? "colorSchemeLight" : "colorSchemeDark"
    )}
                type="button"
                @click=${this._toggleColorScheme}
              >
                <div class="title">${this._t("colorSchemeToggle")}

                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="currentColor" stroke-linecap="round" class="theme-toggle" viewBox="0 0 32 32" width="1.5rem" height="1.5rem">
                  <clipPath id="theme-toggle-cutout">
                    <path d="M0-5h30a1 1 0 0 0 9 13v24H0Z"></path>
                  </clipPath>
                  <g clip-path="url(#theme-toggle-cutout)">
                    <circle cx="16" cy="16" r="9.34"></circle>
                    <g class="theme-toggle-rays" stroke="currentColor" stroke-width="1.5">
                      <path d="M16 5.5v-4"></path>
                      <path d="M16 30.5v-4"></path>
                      <path d="M1.5 16h4"></path>
                      <path d="M26.5 16h4"></path>
                      <path d="m23.4 8.6 2.8-2.8"></path>
                      <path d="m5.7 26.3 2.9-2.9"></path>
                      <path d="m5.8 5.8 2.8 2.8"></path>
                      <path d="m23.4 23.4 2.9 2.9"></path>
                    </g>
                  </g>
                </svg></div>
              </button>
            </li>
            <li>
              <a
                href="mailto:support@captego.com"
                class="item subitem"
              >
                <div class="title">${this._t("help")}</div>
              </a>
            </li>
            <li>
              <a
                class="item subitem"
                href="/signout"
              >
                <div class="title">
                  ${this._t("signOut")}
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    `;
  }
  _renderItem({
    exact: e = !1,
    href: t,
    iconLine: o,
    iconFill: i,
    isParent: s = !1,
    title: r
  }) {
    const n = this.routePath != null && (e ? this.routePath === t : this.routePath.startsWith(t));
    return y`
      <a
        href="${t}"
        class=${j({
      item: !0,
      "item-parent": s,
      "is-active": n
    })}
        @click=${this.navigate}
      >
        <div class="icon">
          <img aria-hidden="true" focusable="false" src=${o} alt="" />
          <img aria-hidden="true" focusable="false" src=${i} alt="" />
        </div>
        <div class="title">${r}</div>
      </a>
    `;
  }
  _renderSubItem({
    exact: e = !1,
    href: t,
    title: o
  }) {
    const i = this.routePath != null && (e ? this.routePath === t : this.routePath.startsWith(t));
    return y`
      <a
        class=${j({
      item: !0,
      subitem: !0,
      "is-active": i
    })}
        href=${t}
        @click=${this.navigate}
      >
        <div class="title">${o}</div>
      </a>
    `;
  }
  _enterNavigation() {
    this._isNavigationHovered = !(this.isExpanded || ot());
  }
  _leaveNavigation() {
    this._isNavigationHovered = !1;
  }
  _toggleNavigation() {
    const e = new Event("nav-toggle");
    document.dispatchEvent(e);
  }
  _collapseNavigation() {
    this.isExpanded && this._toggleNavigation();
  }
  _expandNavigation() {
    this.isExpanded || this._toggleNavigation();
  }
  _toggleColorScheme() {
    const e = new Event("nav-toggle-color-scheme");
    document.dispatchEvent(e);
  }
  _showInvitations() {
    const e = new Event("nav-show-invitations");
    document.dispatchEvent(e);
  }
  navigate(e) {
    const t = e.currentTarget;
    if (t != null && !e.metaKey) {
      const o = t.getAttribute("href");
      if (!((o == null ? void 0 : o.startsWith("http")) || (o == null ? void 0 : o.startsWith("//")))) {
        e.preventDefault();
        const s = new CustomEvent("nav-navigate", {
          detail: {
            href: o
          }
        });
        document.dispatchEvent(s);
      }
    }
    this._isSmallScreen && this._toggleNavigation(), this._hidePopover();
  }
  _logoLoaded() {
    var i, s;
    if (this.logoEl == null)
      return;
    const e = 40, t = (i = this.logoEl) == null ? void 0 : i.clientWidth, o = (s = this.logoEl) == null ? void 0 : s.clientHeight;
    if (t > o) {
      const r = e * (o / t);
      this._logoCenterY = (e - r) / 2;
    } else if (t < o) {
      const r = e * (t / o);
      this._logoCenterX = (e - r) / 2;
    }
  }
  _updatePopover() {
    this.popoverTriggerEl != null && this.popoverContentEl != null && Le(this.popoverTriggerEl, this.popoverContentEl, {
      middleware: [de(10)],
      placement: "top-start"
    }).then(({ x: e, y: t }) => {
      var o;
      Object.assign(((o = this.popoverContentEl) == null ? void 0 : o.style) ?? {}, {
        left: `${e}px`,
        top: `${t}px`
      });
    });
  }
  _t(e) {
    const t = Ui[this.locale];
    return (t == null ? void 0 : t[e]) ?? e;
  }
};
p.styles = Me`
    :host {
      --color-white: #fff;
      --color-alert: #ea3357;
      --color-alert-bg: hsla(348, 81%, 56%, 0.15);
      --color-alert-text: var(--color-white);
      --color-bg-hover: #f5f6f9;
      --color-bg: var(--color-white);
      --color-border: #e5e5e5;
      --color-text-muted: #aaa;
      --color-text: #000;
      --color-toggle: #888;

      --font-sans: 'Mulish Variable', sans-serif;
      --radius-sm: 0.25rem;
      --radius-md: 0.375rem;
      --shadow: 0 1px 3px hsla(0, 0%, 0%, 0.1);
      --shadow-lg: 2px 1px 4px hsla(0, 0%, 0%, 0.1);
      --text-sm: 0.875rem;
      --text-xs: 0.75rem;
      --size-expanded: 13.5rem; /* 216px */
      --size-collapsed: 4.5rem; /* 72px */

      --ease: cubic-bezier(0.16, 1, 0.3, 1);

      box-sizing: border-box;
      font-family: var(--font-sans);
      height: 100vh;
      position: relative;
    }

    :host([color-scheme='dark']) {
      --color-alert: #feb2b2;
      --color-alert-bg: hsla(348, 91%, 86%, 0.15);
      --color-alert-text: #1a202c;
      --color-bg-hover: #2d3748;
      --color-bg: #1a202c;
      --color-border: #2d3748;
      --color-text-inverted: var(--color-white);
      --color-text-muted: #a0aec0;
      --color-text: #e5e7eb;
      --color-toggle: #a0aec0;
    }

    *,
    *::before,
    *::after {
      box-sizing: inherit;
    }

    button {
      appearance: none;
      background: none;
      border: none;
      color: currentColor;
      cursor: pointer;
      padding: 0;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    @media print {
      .wrapper {
        display: none !important;
      }
    }

    .wrapper {
      --size-current: var(--size-expanded);
    }
    .wrapper.is-collapsed:not(.is-hovered) {
      --size-current: var(--size-collapsed);
    }

    .nav {
      background-color: var(--color-bg);
      border-bottom: var(--color-border);
      box-shadow: var(--shadow);
      display: grid;
      grid-template-rows: auto 1fr auto;
      user-select: none;
      height: 100vh;
      padding: 1rem;
      position: fixed;
      overflow: hidden;
      z-index: 1;
      transition:
        background 0.2s var(--ease),
        color 0.2s var(--ease),
        transform 0.2s var(--ease),
        width 0.2s var(--ease);
      width: var(--size-current);
    }
    .is-touch .nav {
      height: 100dvh;
    }

    @media (max-width: 44.9rem) {
      .is-collapsed .nav {
        transform: translateX(-100%);
      }
    }

    .toggle-mobile {
      box-shadow: var(--shadow);
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--color-white);
      border-radius: var(--radius-sm);
      width: 2.75rem;
      height: 2.75rem;
      position: fixed;
      left: 0.625rem;
      top: 0.375rem;
    }
    .toggle-mobile img {
      width: 1.125rem;
      height: 1.125rem;
    }

    .toggle {
      background-color: var(--color-bg);
      border: 1px solid transparent;
      border-radius: var(--radius-sm);
      color: var(--color-toggle);
      width: 1.5rem;
      height: 1.5rem;
      transition:
        background 0.2s var(--ease),
        color 0.2s var(--ease),
        opacity 0.2s var(--ease),
        transform 0.2s var(--ease);
    }
    .toggle.is-hidden {
      display: none;
    }
    .toggle::before {
      content: '';
      width: 2.5rem;
      min-height: 2.5rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .toggle:hover {
      background-color: var(--color-bg-hover);
      color: var(--color-text);
    }

    .toggle img {
      transition: transform 0.2s var(--ease);
    }

    .toggle-primary {
      position: absolute;
      top: 0;
      right: 0;
    }

    .toggle-secondary {
      border-color: var(--color-toggle);
      margin-left: auto;
      margin-top: 1.25rem;
    }

    .is-collapsed:not(.is-hovered) .toggle-secondary {
      transform: translateX(-50%);
      margin-left: 1.25rem;
    }

    .is-collapsed .toggle img {
      transform: rotate(-180deg);
    }

    .is-collapsed .toggle-primary {
      border-color: var(--color-toggle);
      opacity: 0;
    }

    .is-hovered .toggle {
      opacity: 1;
    }

    .top {
      background-color: var(--color-bg);
      position: relative;
      margin-bottom: 1rem;
      transition:
        background 0.2s var(--ease),
        color 0.2s var(--ease);
    }

    .middle {
      -webkit-overflow-scrolling: touch;
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 2.5rem;
    }

    .bottom {
      background-color: var(--color-bg);
      display: flex;
      flex-direction: column;
      position: relative;
      transition:
        background 0.2s var(--ease),
        color 0.2s var(--ease);
    }

    .logo {
      height: 4rem;
      width: calc(var(--size-expanded) - 4.75rem);
      overflow: hidden;
      transition:
        height 0.2s var(--ease),
        width 0.2s var(--ease);
      position: relative;
    }
    .logo svg {
      height: 100%;
      transition:
        height 0.2s var(--ease),
        width 0.2s var(--ease);
    }
    .is-collapsed:not(.is-hovered) .logo {
      width: 2.5rem;
    }
    .is-collapsed:not(.is-hovered) .logo svg {
      height: 2.5rem;
    }

    .logo a {
      display: flex;
      align-items: flex-start;
      height: 100%;
      position: relative;
    }

    .logo img {
      display: block;
      object-fit: contain;
      max-width: 100%;
      max-height: 100%;
      height: auto;
      transition: transform 0.2s var(--ease);
    }
    .is-collapsed:not(.is-hovered) .logo img {
      transform: translate(
        calc(1px * var(--center-x, 0)),
        calc(1px * var(--center-y, 0))
      );
    }

    .divider-above,
    .divider-below {
      position: relative;
    }
    .divider-above::before,
    .divider-below::before {
      background-color: var(--color-border);
      content: '';
      height: 1px;
      position: absolute;
      left: 0;
      width: calc(var(--size-current) - 2rem);
    }

    .divider-above {
      margin-top: 1rem;
      padding-top: 1rem;
    }
    .divider-above::before {
      top: 0;
    }

    .divider-below {
      margin-bottom: 1rem;
      padding-bottom: 1rem;
    }
    .divider-below::before {
      bottom: 0;
    }

    .item {
      --item-bg: var(--color-bg-hover);
      color: var(--color-text);
      display: flex;
      align-items: center;
      gap: 0.75rem;
      font-size: var(--text-sm);
      padding: 0.5rem;
      position: relative;
      min-height: 2.5rem;
      text-decoration: none;
      white-space: nowrap;
      transition:
        background 0.2s var(--ease),
        color 0.2s var(--ease);
      text-align: left;
      overflow: hidden;
      width: calc(var(--size-expanded) - 2rem);
    }
    .item::before {
      border-radius: 0.5rem;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      transition: width 0.2s var(--ease);
    }
    .is-collapsed:not(.is-hovered) .item::before {
      width: calc(var(--size-collapsed) - 2rem);
    }

    :is(
        .item[data-popper-shown],
        .item:not(.item-parent).is-active,
        .item:hover,
        .item:focus-visible
      )::before {
      background-color: var(--item-bg);
    }

    :is(
        .item[data-popper-shown],
        .item.is-active,
        .item:hover,
        .item:focus-visible
      )
      img:first-child {
      opacity: 0;
    }

    :is(
        .item[data-popper-shown],
        .item.is-active,
        .item:hover,
        .item:focus-visible
      )
      img:last-child {
      opacity: 1;
    }

    .is-collapsed:not(.is-hovered) .item {
      width: calc(var(--size-expanded) - 2rem);
    }

    .subitem {
      overflow: hidden;
      width: calc(var(--size-expanded) - 2rem - 2rem);
      padding: 0 1rem;
    }

    .icon {
      flex-shrink: 0;
      width: 1.5rem;
      height: 1.5rem;
      position: relative;
    }
    .icon img {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1.125rem;
      height: 1.125rem;
      transform: translate(-50%, -50%);
      transition: opacity 0.2s var(--ease);
    }
    :host([color-scheme='dark']) .icon img {
      filter: invert(1);
    }
    .icon img:last-child {
      opacity: 0;
    }

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 1;
      position: relative;
      transition: opacity 0.2s var(--ease);
      width: 100%;
    }
    .is-collapsed:not(.is-hovered) .title {
      opacity: 0;
    }

    .item-arrow {
      margin-left: auto;
    }

    .sublist {
      margin-left: 2rem;
      margin-top: 0.5rem;
      position: relative;
    }
    .sublist::before {
      background-color: var(--color-border);
      content: '';
      height: 100%;
      left: calc(-0.75rem - 1px);
      position: absolute;
      top: 0;
      width: 1px;
    }
    .is-collapsed:not(.is-hovered) .sublist {
      display: none;
    }

    .invitations {
      --item-bg: var(--color-alert-bg);
      color: var(--color-alert);
      margin-bottom: 0.5rem;
    }

    .invitations-counter {
      color: var(--color-alert-text);
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      font-size: var(--text-xs);
      font-weight: var(--font-weight-bd);
      position: relative;
      width: 1.5rem;
      height: 1.5rem;
      text-align: center;
      margin-left: 0.125rem;

      background-color: var(--color-alert);
      border-radius: 50%;
      width: 1.25rem;
      height: 1.25rem;
    }

    .popover-trigger {
      line-height: 1.3;
      white-space: normal;
    }

    .popover-content {
      background: var(--color-bg);
      box-shadow: var(--shadow-lg);
      border: 0 solid var(--color-border);
      border-left-width: 1px;
      border-radius: 0 var(--radius-md) var(--radius-md) 0;
      color: var(--color-text);
      transform: translateX(calc(1.25rem - 1px));
      transition:
        background 0.2s var(--ease),
        color 0.2s var(--ease);
      display: none;
      position: absolute;
      width: 13rem;
      top: 0;
      left: 0;
      z-index: 2;
    }
    .popover-content.is-active {
      display: block;
    }

    .accountlist {
      font-size: var(--text-sm);
      padding: 0.5rem;
      width: 100%;
      min-width: calc(var(--size-expanded) - 2rem);
    }

    .user-info {
      padding: 0.5rem 0.5rem 0 0.5rem;
    }

    .accountlist .subitem {
      width: 100%;
    }

    .vstack-sm {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
    }

    .text-muted {
      color: var(--color-text-muted);
    }

    .text-xxs {
      font-size: 0.6875rem;
    }

    .theme-toggle path {
      transition-timing-function: var(--ease);
      transform-origin: center;
      transition-duration: 0.4s;
    }

    .theme-toggle-rays path {
      transition-property: opacity, transform;
      transition-delay: 0.3s;
    }
    :host([color-scheme='dark']) .theme-toggle-rays path {
      opacity: 0;
      transform: scale(0.5) rotate(45deg);
    }

    .theme-toggle :first-child path {
      transition-property: transform, d;
      transition-delay: 0.3s;
    }
    :host([color-scheme='dark']) .theme-toggle :first-child path {
      d: path('M-12 5h30a1 1 0 0 0 9 13v24h-39Z');
    }
  `;
u([
  v({ attribute: "color-scheme", type: String })
], p.prototype, "colorScheme", 2);
u([
  v({ attribute: "company-id", type: String })
], p.prototype, "companyId", 2);
u([
  v({ attribute: "company-name", type: String })
], p.prototype, "companyName", 2);
u([
  v({ attribute: "custom-reports-url", type: String })
], p.prototype, "customReportsUrl", 2);
u([
  v({ attribute: "is-expanded", type: Boolean })
], p.prototype, "isExpanded", 2);
u([
  v({ attribute: "is-loading", type: Boolean })
], p.prototype, "isLoading", 2);
u([
  v({ type: Number })
], p.prototype, "invitations", 2);
u([
  v({ type: String })
], p.prototype, "logo", 2);
u([
  v({ type: String })
], p.prototype, "locale", 2);
u([
  v({ attribute: "route-path", type: String })
], p.prototype, "routePath", 2);
u([
  v({ attribute: "show-access-control", type: Boolean })
], p.prototype, "showAccessControl", 2);
u([
  v({ attribute: "show-accounts", type: String })
], p.prototype, "showAccounts", 2);
u([
  v({ attribute: "show-custom-reports", type: Boolean })
], p.prototype, "showCustomReports", 2);
u([
  v({ attribute: "show-report-templates", type: Boolean })
], p.prototype, "showReportTemplates", 2);
u([
  v({ attribute: "show-company", type: String })
], p.prototype, "showCompany", 2);
u([
  v({ attribute: "show-templates", type: String })
], p.prototype, "showTemplates", 2);
u([
  v({ attribute: "user-id", type: String })
], p.prototype, "userId", 2);
u([
  v({ attribute: "user-email", type: String })
], p.prototype, "userEmail", 2);
u([
  v({ attribute: "user-name", type: String })
], p.prototype, "userName", 2);
u([
  v({ attribute: "user-phone-number", type: String })
], p.prototype, "userPhoneNumber", 2);
u([
  R()
], p.prototype, "_isAccountShown", 2);
u([
  R()
], p.prototype, "_isNavigationHovered", 2);
u([
  R()
], p.prototype, "_logoCenterX", 2);
u([
  R()
], p.prototype, "_logoCenterY", 2);
u([
  R()
], p.prototype, "_isSmallScreen", 2);
u([
  R()
], p.prototype, "_wasExpanded", 2);
u([
  R()
], p.prototype, "_mql", 2);
u([
  ht(".logo")
], p.prototype, "logoEl", 2);
u([
  ht(".nav")
], p.prototype, "navEl", 2);
u([
  ht(".popover-trigger")
], p.prototype, "popoverTriggerEl", 2);
u([
  ht(".popover-content")
], p.prototype, "popoverContentEl", 2);
p = u([
  Ke("captego-nav")
], p);
export {
  p as CaptegoNav
};
